import { Color } from '@persona-id/design-tokens';
import { useMemo } from 'react';
import styled from 'styled-components';

import BarChartWithLegend from 'dashboard/components/BarChartWithLegend';
import LoadingOverlay from 'dashboard/components/LoadingOverlay';
import { Period } from 'dashboard/lib/unixTime';
import { fillChartData } from 'dashboard/lib/utils/charting';
import {
  formatChartDate,
  formatChartDateLong,
  formatChartDateLongWithDay,
} from 'dashboard/lib/utils/formatters';
import { MetricsTransactionVolumeOverTime } from 'dashboard/models/metrics-transaction';
import Card from 'design-system/components/Card';

const COLORS = [Color.CoreTeal100, Color.CorePurple800, Color.CoreTeal900];

const Container = styled.section``;

interface TransactionMetricsProps {
  isLoading: boolean;
  volumeOverTime: MetricsTransactionVolumeOverTime;
  period: Period;
}

const TransactionMetrics = ({ isLoading, volumeOverTime, period }: TransactionMetricsProps) => {
  const filledData = useMemo(() => {
    return fillChartData(
      volumeOverTime.data,
      {
        created: 0,
      },
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      volumeOverTime.domain,
      volumeOverTime.period,
      false,
    );
  }, [volumeOverTime.data, volumeOverTime.domain, volumeOverTime.period]);

  const createTooltipHeader = (label: number) => {
    return period === 'week'
      ? `Week of ${formatChartDateLong(label)}`
      : formatChartDateLongWithDay(label);
  };

  return (
    <Container data-test='transaction-metrics__chart-container'>
      <Card>{isLoading && <LoadingOverlay />}</Card>
      <Card>
        <Card.Body>
          <Card.Title>Created</Card.Title>
          <BarChartWithLegend
            legendFormatter={(value: string) => value.toUpperCase()}
            hideLegend={true}
            data={filledData}
            barKeys={['created']}
            barColors={COLORS}
            stackId='output'
            xDataKey='created_timestamp'
            xFormatter={formatChartDate}
            /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
            createTooltipHeader={createTooltipHeader}
            allowEscapeViewBoxX={false}
          />
        </Card.Body>
      </Card>
    </Container>
  );
};

export default TransactionMetrics;
